import { useCallback, useRef, useState } from 'react';
import { createCompanyCurrency } from 'services/Configuration/companyCurrenciesService';

export function useCreateCompanyCurrency() {
  const [createdCurrency, setCreatedCurrency] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const createCurrency = useCallback(async (data) => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;
    setIsLoading(true);
    setError(null);
    try {
      const result = await createCompanyCurrency(data, controller.signal);
      setCreatedCurrency(result);
      return result;
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { createdCurrency, isLoading, error, createCurrency };
}
